import Vue from "vue";
import Loading from "./Loading.vue";

const loadingDirective = {
  inserted: function (el, binding) {
    const LoadingCtor = Vue.extend(Loading);
    const loadingInstance = new LoadingCtor();
    el.instance = loadingInstance.$mount();
    if (binding.value) {
      append(el);
    }
  },
  update(el, binding) {
    if (binding.value !== binding.oldValue) {
      binding.value ? append(el) : remove(el);
    }
  },
};

function append(el) {
  el.appendChild(el.instance.$el);
}

function remove(el) {
  el.removeChild(el.instance.$el);
}

export default loadingDirective;
